import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import WorkspacePage from './pages/WorkspacePage';
import Header from './components/Header';
import ExportJobsStatusBar from './components/ExportJobsStatusBar';
import { ExportJobsProvider } from './hooks/useExportJobs';
import { useFetchSessionInfo, api_host } from './apiClient';
import Spinner from 'react-bootstrap/Spinner';
import { AppContextProvider } from './utils/AppContext';
import CampaignDetailPage from './pages/CampaignDetailPage';
import SharePage from './pages/SharePage';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import { trackPageView } from './utils/analytics';
import AdminDashboardPage from './pages/AdminDashboardPage';

function RouteChangeTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return null;
}

function App() {
  const { isLoggedIn, isLoading, username, isStaff, isSuperuser } =
    useFetchSessionInfo();

  // update campaign filter list when  reating campaign ID
  const [updateCampaignFilter, setUpdateCampaignFilter] =
    useState<boolean>(false);

  if (isLoading) {
    return (
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spinner
          style={{ width: '5rem', height: '5rem' }}
          animation="border"
          variant="primary"
        />
      </div>
    );
  }

  // redirect to login page if not logged in
  const LoginRedirect = () => {
    useEffect(() => {
      window.location.href = `${api_host}/accounts/login`;
    }, []);
    return null;
  };

  const UnauthenticatedRoutes = () => (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/*" element={<LoginRedirect />} />
    </Routes>
  );

  const MainApp = () => (
    <AppContextProvider
      initialUsername={username}
      initialIsStaff={isStaff}
      initialIsSuperuser={isSuperuser}
    >
      <ExportJobsProvider>
        <ExportJobsStatusBar />
        <Header setUpdateCampaignFilter={setUpdateCampaignFilter} />
        <Routes>
          <Route
            path="/"
            element={
              <WorkspacePage updateCampaignFilter={updateCampaignFilter} />
            }
          />
          <Route path="/campaign/:campaignId" element={<CampaignDetailPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
        </Routes>
      </ExportJobsProvider>
    </AppContextProvider>
  );

  return (
    <Router>
      <RouteChangeTracker />
      <Routes>
        <Route path="/share" element={<SharePage />} />
        <Route
          path="/*"
          element={isLoggedIn ? <MainApp /> : <UnauthenticatedRoutes />}
        />
      </Routes>
    </Router>
  );
}

export default App;
